import { useNavigate } from "react-router-dom";
import { FullScreenSpinner } from "../../tabin/components/fullScreenSpinner";
import { Button } from "../../tabin/components/button";

import "./restaurantList.scss";
import { useListRestaurantsQuery } from "../../hooks/useGetRestaurantsQuery";
import { useCart } from "../../context/cart-context";
import { useState, useEffect } from "react";

const images = [
    "https://images.squarespace-cdn.com/content/v1/57b0e6a320099e871dd6b107/1624318843743-5W503K55Q20U0JD8HPC3/BB_24_March-66.jpg?format=2500w",
    "https://images.squarespace-cdn.com/content/v1/57b0e6a320099e871dd6b107/1623904332991-GGW7S6UV8ZE5QL4JV52F/BB_Groupings25.jpg?format=2500w",
    // Add more images here in the future
];

export const restaurantDataList = [
    // { id: "0866523d-739a-4be9-a2bd-74fdd2343442", name: "Apple Test", address: "Test Address", available: true },
    // { id: "bb78c4dd-2f53-4684-9201-ca64438130f8", name: "HQ", address: "Test Address", available: true },
    {
        id: "d8a0e19f-dfb3-4e69-bb99-a2533fd09627",
        name: "Botany",
        address: "500 Ti Rakau Drive, Botany Downs, Auckland",
        available: true,
    },
    {
        id: "342091b7-7b23-40f7-b380-a86bea2a2c90",
        name: "Christchurch",
        address: "88 Hereford Street, Christchurch Central City, Christchurch 8011",
        available: true,
    },
    {
        id: "bde22d98-58ee-4153-b8be-ebdbf0bae807",
        name: "Customs St, Auckland CBD",
        address: "22 Customs Street East, Auckland CBD, Auckland 1010",
        available: true,
    },
    {
        id: "d22ecc1b-dc1e-4041-a526-98df6146777a",
        name: "Lynn Mall",
        address: "3058 Great North Road, New Lynn, Auckland 0600",
        available: true,
    },
    {
        id: "a8299d94-2aba-4e74-b9b1-f5a753f6ca79",
        name: "Mānawa Bay",
        address: "4 Jimmy Ward Crescent, Auckland Airport, Auckland 2022",
        available: true,
    },
    {
        id: "f479b649-0fde-48d5-9be9-41ea289d936d",
        name: "Manukau",
        address: "Manukau Supa Centa Cavendish Drive, Manukau City Centre, Auckland 2104",
        available: true,
    },
    {
        id: "53a2c8fe-d620-48a4-ac6b-69854424180d",
        name: "Ormiston",
        address: "William Ralph Road, Ormiston, Auckland",
        available: true,
    },
    {
        id: "bc6623fa-8e45-4088-9bf4-4b7679b416e7",
        name: "Ponsonby",
        address: "45 Ponsonby Road, Ponsonby, Auckland",
        available: true,
    },
    {
        id: "cc7884b6-cacf-4fdb-9211-9a1f9c5a5fb6",
        name: "Sylvia Park",
        address: "286 Mount Wellington Highway, Auckland",
        available: true,
    },
    {
        id: "d935d8e4-f30f-466b-8147-7c60a5e838ad",
        name: "Tauranga",
        address: "Shop RR203, 2 Taurikura Drive, Tauriko, Tauranga",
        available: true,
    },
    {
        id: "0aec9c5c-b2a7-4803-8b01-69ee93bc8bf9",
        name: "Whangaparaoa",
        address: "6 Main Street, Stanmore Bay, Whangaparāoa 0932",
        available: true,
    },
];

const Banner = ({ onClick }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change every 3 seconds

        return () => clearInterval(intervalId); // Clean up the interval on component unmount
    }, []);

    return (
        <>
            <div className="bb-logo mt-2">
                <img
                    src="https://d1hfsnuz4i23pd.cloudfront.net/public/2024-08-28_03:59:03.132-361291020_657278139757168_5075971016856581513_n.webp"
                    width="100px"
                />
            </div>
            <div className="slideshow-container">
                <img src={images[currentIndex]} alt="Slideshow Banner" className="slideshow-image" />
            </div>
            <div className="restaurantlist-button-wrapper">
                <Button onClick={onClick} className="restaurantlist-button">
                    Order Now
                </Button>
            </div>
        </>
    );
};

const Restaurants = () => {
    const navigate = useNavigate();
    // const { data, error, loading } = useListRestaurantsQuery();
    const { products } = useCart();

    // useEffect(() => {
    //         const cameFromCheckoutPage = sessionStorage.getItem("cameFromCheckoutPage");

    //         if (cameFromCheckoutPage == "true" && products && products.length > 0) {
    //             history.replace("/checkout");
    //         }
    // }, []);

    // if (loading) {
    //     return <FullScreenSpinner show={true} text="Loading restaurants" />;
    // }

    // if (error) {
    //     return <div>Error! {error.message}</div>;
    // }

    const onOrder = (restaurantId: string) => {
        navigate(`/${restaurantId}`);
    };

    return (
        <>
            <div className="restaurant-list">
                <div className="h2 mb-6">Select a restaurant to access </div>
                {restaurantDataList
                    // .filter((r) => r.verified === true)
                    // .sort((a, b) => (a.name > b.name && 1) || -1)
                    .map((restaurant, index) => (
                        <div key={restaurant.id}>
                            {index != 0 && <div className="separator-4"></div>}
                            <div className="restaurant-list-item">
                                <div className="restaurant-name-wrapper">
                                    <div className="restaurant-name text-bold mb-2">{restaurant.name}</div>
                                    <div className="restaurant-address">{restaurant.address}</div>
                                </div>
                                <Button
                                    className={`${restaurant.available ? "" : "disabled"}`}
                                    onClick={() => {
                                        restaurant.available && onOrder(restaurant.id);
                                    }}
                                >
                                    {restaurant.available ? "Order" : "Unavailable"}
                                </Button>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};

export const RestaurantList = () => {
    const [showBannerPage, setShowBannerPage] = useState(true);

    return <>{showBannerPage ? <Banner onClick={() => setShowBannerPage(false)} /> : <Restaurants />}</>;
};
